import { Inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { CommonService }from './common.service'
import { DialogService } from './dialog.service'
import { HttpResponse } from '@angular/common/http'
import { ErrorService } from './error.service'

@Injectable({
    providedIn: 'root'
})
export class FileDownloadService {

    constructor(@Inject(CommonService) private commonService: CommonService,
                @Inject(DialogService) private dialogService: DialogService,
                @Inject(ErrorService) private errorService: ErrorService,
                ) {
    }

    downloadFile(request: Observable<HttpResponse<Blob>>): void {
        this.commonService.showActionProgress('Probíhá stažení souboru.')

        request.subscribe(result => {
            if (result.status === 204) { // no content
                this.commonService.hideActionProgress()
                return this.dialogService.showWarningDialog('Nebyl vygenerován žádný soubor. Opravte prosím filtrační podmínku.')
            }

            const contentType = result.headers.get('Content-Type')
            const filename = this.getFilenameFromContentDisposition(result.headers.get('Content-Disposition'))

            const linkElement = document.createElement('a')

            const blob = new Blob([result.body], {type: contentType})
            const url = window.URL.createObjectURL(blob)

            linkElement.setAttribute('href', url)
            linkElement.setAttribute('download', filename)

            const clickEvent = new MouseEvent('click', {
                'view': window,
                'bubbles': true,
                'cancelable': false
            })

            linkElement.dispatchEvent(clickEvent)
            linkElement.remove()

            this.commonService.hideActionProgress()
        }, error => {
            this.commonService.hideActionProgress()
            if (!error.data && error.error) {
                error.data = error.error
            }
            if (error.data && error.data instanceof Blob && error.data.size > 0) {
                this.errorService.getErrorObjectFromBlob(error.data).then(errorObj => {
                    this.errorService.onErrorResponseAlertUser(errorObj)
                })
            } else {
                error.error.message = ''
                this.errorService.onErrorResponseAlertUser(error, 'Chyba při stahování souboru. Zkontrolujte nastavení filtru pomocí "Najdi".')
            }
        })
    }

    private getFilenameFromContentDisposition(contentDisposition): string {
        if (contentDisposition && typeof contentDisposition === 'string' && contentDisposition.trim() !== '') {
            return this.parseContentDispositionFilename(contentDisposition)
        }

        return 'unknown'
    }

    private parseContentDispositionFilename(contentDisposition): string {
        const filename = this.getFilename(contentDisposition)
        if (filename) {
            return unescape(decodeURI(filename))
        }
        else {
            throw new Error('content-disposition filename cannot be empty')
        }
    }

    private getFilename(contentDisposition): string {
        const filenames = this.getFilenameParams(contentDisposition)
        if (filenames.filenamestar) {
            // RFC 6266 4.1 filename* -> RFC 5987 3.2.1 ext-value
            return filenames.filenamestar.replace(/^(?<charset>.+)'(?<language>.*)'(?<filename>.+)$/, '$<filename>')
        }
        else if (filenames.filename) {
            // RFC 6266 4.1 filename (possibly quoted)
            return filenames.filename.replace(/^"(?<filename>.+)"$/, '$<filename>')
        }
        else {
            return undefined
        }
    }

    private getFilenameParams(contentDisposition): any {
        // Split using  (if not quoted) and skip the first element since it's `disposition-type`
        const [, ...dispositionParams] = contentDisposition.split(/(?!\B"[^"]*)\s(?![^"]*"\B)/)
        return {
            filenamestar: this.getParamValue('filename\\*', dispositionParams),
            filename: this.getParamValue('filename', dispositionParams),
        }
    }

    private getParamValue(paramName, params): string {
        const regex = new RegExp('^\\s*' + paramName + '=(?<paramValue>.+)\\s*$', 'i')
        return params.find(p => p.match(regex)?.groups?.['paramValue'])
    }
}